import React, { useState } from 'react';
import PropTypes from 'prop-types'
import { useStaticQuery, graphql } from "gatsby";
import axios from 'axios'
import { navigate } from 'gatsby';
import ReCAPTCHA from "react-google-recaptcha";

import Button from 'components/buttons/button';
import RenderRichText from 'utils/richText/renderRichText';

import { StyledInput, StyledNewsletterForm } from 'components/newsletterForm/styled';

import validate from 'components/newsletterForm/validateForm';
import filterPrismicDataByLanguage from 'utils/functions/filterPrismicDataByLanguage';
import createProperties from 'utils/functions/createProperties';

const emailNewsletterEndpoint = process.env.GATSBY_EMAIL_NEWSLETTER_URL;

const recaptchaRef = React.createRef();

const FormSlice = ({ slice, preview, language }) => {
  const data = useStaticQuery(graphql`
    query newsletterErrorMessagesQuery {
      allPrismicPropertiesErrorMessages {
        edges {
          node {
            lang
            data {
              invalid_email_address
              invalid_first_name
              invalid_second_name
              required_email_address
              required_information_mesage
            }
          }
        }
      }
    }
  `)

  const errorMessages = filterPrismicDataByLanguage(data.allPrismicPropertiesErrorMessages.edges, language);
  const errorMessage = errorMessages.node.data;
  const { urls } = createProperties(language);

  const useNewsLetterUpForm = (callback) => {
    const [inputs, setInputs] = useState({});
    const [errors, setErrors] = useState({});

    const handleSubmit = async (event) => {
      if (event) {
        event.preventDefault();

        if (Object.keys(inputs).length !== 3 || Object.keys(errors).length > 0) {
          recaptchaRef.current.reset();
          setErrors(validate(inputs));

          return false
        } else {
          const token = await recaptchaRef.current.executeAsync()

          if (token) {
            axios({
            url: `https://9n8goq9i82.execute-api.eu-west-1.amazonaws.com/dev/verify-token`, 
            method: 'POST',
            data: {
              token: token
            },
            headers: {
              'Content-Type': "application/json"
            },
          })
          .then(res => {
            axios.post(emailNewsletterEndpoint, inputs)
            .then(data => {
              navigate(urls.newsletterThanks);
            })
            .catch(err => {
              console.log(err)
            })
          })
          .catch(error => {
            console.log("Err", error)
          })
          }
        }
      }
    }

    const handleInputChange = (event) => {
      event.persist();
      const name = event.target.name

      if (!event.target.value) {
        setErrors(errors => ({...errors, [event.target.name]: errorMessage.required_information_mesage}));
      } 
      else delete errors[name]

      if (name === "email") {
        if (!/\S+@\S+\.\S+/.test(event.target.value)) {
          setErrors(errors => ({...errors, [event.target.name]: errorMessage.invalid_email_address}));
        } 
        else delete errors[name] 
      }

      setInputs(inputs => ({...inputs, [event.target.name]: event.target.value}));
    }

    return {
      handleSubmit,
      handleInputChange,
      inputs,
      errors
    };
  }

  const { errors, inputs, handleInputChange, handleSubmit} = useNewsLetterUpForm();

  return (
    <React.Fragment>
      <form
        onSubmit={handleSubmit} 
        id="emailNewsletter"
        method="post"
      >
      
        <StyledNewsletterForm>
          {slice.items.map((el, index) => {
            let name;
            let inputError;
            let inputErrorMsg;

            switch (index) {
              case 0:
                name = "firstName";
                inputError = errors.firstName; 
                inputErrorMsg = errorMessage.required_information_mesage;
                break
              case 1:
                name = "surName";
                inputError = errors.surName;
                inputErrorMsg = errorMessage.required_information_mesage;
                break
              case 2:
                name = "email";
                inputError = errors.email;
                inputErrorMsg = errorMessage.invalid_email_address;
                break
              default:
                null
          }

          return (
            <div>
              <StyledInput 
                onChange={handleInputChange} 
                name={name}
                value={inputs.name}
                placeholder={el.input_placeholder} 
                setErrorBorderColor={inputError}
                inputError={inputError}
              />
              {inputError && 
              (
                <div style={{marginBottom: '20px'}}>
                  <i className='warning-icon' />
                  <span style={{fontSize: '12px', fontFamily: 'Raleway, sans-serif', color: "#46344e"}}>{inputErrorMsg}</span> 
                </div>
              )}
            </div>
          )
      })}
        </StyledNewsletterForm>
        <RenderRichText richTextArray={preview ? slice.primary.form_text : slice.primary.form_text.raw} />
        <p style={{textAlign: "center"}}>
          <Button
            fontColor="white"
            marginBottom='1em'
            padding='13px 40px'
            fontSize='14px'
            fontWeight='500'
            text={slice.primary.button_text}
            htmlType="button"
          />
        </p>
        <ReCAPTCHA
          ref={recaptchaRef}
          sitekey="6LcB2bAZAAAAAE0U_VspDN4FcnCQOdazgwpUXQJN"
          size="invisible"
        />
      </form>
    </React.Fragment>
  )
}

FormSlice.propTypes = {
  language: PropTypes.string,
  preview: PropTypes.bool,
  slice: PropTypes.object
}

export default FormSlice
